import { OverlayPositionBuilder } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '@content-platform/web-angular-shared-util-pipes';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltipDefaultOptions,
  MatTooltipModule,
} from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import {
  WebAngularSharedDataAccessApplicationApiModule,
  PermissionsModule,
} from '@content-platform/web/angular/shared/data-access/application-api';
import { AuthModule } from '@content-platform/web-angular-shared-util-auth';
import { DevelopmentModule } from '@content-platform/web-angular-shared-util-development';
import { LoggingModule } from '@content-platform/web-angular-shared-util-logging';
import { FooterComponent } from './footer/footer.component';
import { ApplicationsMenuComponent } from './header/applications-menu/applications-menu.component';
import { NavBarComponent } from './header/nav-bar/nav-bar.component';
import { UserMenuComponent } from './header/user-menu/user-menu.component';
import { NotPropertyPipe } from './not-property.pipe';
import { SidenavMenuItemComponent } from './sidenav-menu-item/sidenav-menu-item.component';
import { ExtendedPositionBuilder } from './sidenav/sidenav-menu-position-strategy';
import { SideNavComponent } from './sidenav/sidenav.component';
import { ContentHeaderBarComponent } from './header/content-header-bar/content-header-bar.component';
import { ContentHeaderBarService } from './header/content-header-bar/content-header-bar.service';
import { NAVIGATION_OPTIONS, NavigationOptions } from './navigation-options';
import { ContentHeaderButtonComponent } from './header/content-header-button/content-header-button.component';
import { ReusableUiUserRequestModule } from '@content-platform/reusable-ui/user-request';
import { ReusableUiFeatureFlagsModule } from '@content-platform/reusable-ui/feature-flags';
import { Configuration } from '@content-platform/web-angular-shared-util-configuration';
import { MdePopoverModule } from '@material-extended/mde';
import { AdditionalPartnerInfoPopupComponent } from './header/additional-partner-info-popup/additional-partner-info-popup.component';

export const customTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 1000,
  hideDelay: 500,
  touchendHideDelay: 500,
};

export function optionsFactory(): NavigationOptions {
  return {
    production: Configuration.isProductionEquivalentEnvironment(),
  };
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    ReactiveFormsModule,
    RouterModule,
    MatListModule,
    MatIconModule,
    AuthModule,
    WebAngularSharedDataAccessApplicationApiModule,
    MatToolbarModule,
    MatButtonModule,
    MatInputModule,
    MatMenuModule,
    MatAutocompleteModule,
    MatGridListModule,
    MatSidenavModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatRippleModule,
    MatExpansionModule,
    DevelopmentModule,
    LoggingModule,
    MatDialogModule,
    MatCardModule,
    MatSelectModule,
    MatOptionModule,
    PermissionsModule,
    ReusableUiUserRequestModule,
    ReusableUiFeatureFlagsModule,    
    MdePopoverModule,
  ],
  declarations: [
    ApplicationsMenuComponent,
    FooterComponent,
    NavBarComponent,
    SideNavComponent,
    SidenavMenuItemComponent,
    UserMenuComponent,
    NotPropertyPipe,
    ContentHeaderBarComponent,
    AdditionalPartnerInfoPopupComponent,
    ContentHeaderButtonComponent,
  ],
  exports: [
    FooterComponent,
    NavBarComponent,
    SidenavMenuItemComponent,
    SideNavComponent,
    ContentHeaderBarComponent,
    AdditionalPartnerInfoPopupComponent,
    UserMenuComponent,
    NotPropertyPipe
  ],
  providers: [
    ContentHeaderBarService,
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: customTooltipDefaults },
    { provide: OverlayPositionBuilder, useClass: ExtendedPositionBuilder },
  ],
})
export class NavigationModule {
  constructor(public matIconRegistry: MatIconRegistry) {
    matIconRegistry.registerFontClassAlias('fontawesome', 'fa');
  }
  static forRoot(): ModuleWithProviders<NavigationModule> {
    return {
      ngModule: NavigationModule,
      providers: [{ provide: NAVIGATION_OPTIONS, useFactory: optionsFactory }],
    };
  }
}
